import React from 'react';
import { Field, Input, Label, ValidationMessage } from '@innovationnorway/cl-react';
import { FormGroupErrorContext } from './FormGroup';

type InputType = React.ComponentProps<typeof Input>['type'];

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  error?: React.ReactNode | boolean;
  id?: string;
  inputClassName?: string;
  label?: React.ReactNode;
  description?: React.ReactNode;
  name?: string;
  maxCount?: number;
  helpText?: React.ReactNode;
}

const InputWrapper = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      error,
      id,
      inputClassName,
      label,
      description,
      name,
      helpText,
      type = 'text',
      ...props
    }: InputProps,
    ref,
  ) => {
    const context = React.useContext(FormGroupErrorContext);
    const resolvedError = context.error || error;
    const resolvedDescription = description ?? helpText;

    return (
      <Field className={className}>
        {label && (
          <Label>
            {label}
            {props.required && ' *'}
          </Label>
        )}

        {resolvedDescription && <Field.Description data-size="sm">{resolvedDescription}</Field.Description>}

        <Input
          type={type as InputType}
          ref={ref}
          id={id}
          name={name}
          className={inputClassName}
          aria-invalid={!!resolvedError}
          {...props}
        />

        {!context.error && !!error && typeof error !== 'boolean' && (
          <ValidationMessage>{error}</ValidationMessage>
        )}
      </Field>
    );
  },
);

InputWrapper.displayName = 'InputWrapper';

export default InputWrapper;
